const expandHexToSixDigits = (hex) => {
  if (typeof hex !== "string") return null;

  if (/^#[A-Fa-f0-9]{3}$/.test(hex)) {
    const [r, g, b] = hex.slice(1);

    return `#${r}${r}${g}${g}${b}${b}`;
  }

  if (/^#[A-Fa-f0-9]{6}$/.test(hex)) {
    return hex;
  }

  return null;
};

const hexToRgb = (hex) => {
  const expandedHex = expandHexToSixDigits(hex);

  if (!expandedHex) return null;

  const raw = expandedHex.slice(1);
  const r = Number.parseInt(raw.slice(0, 2), 16);
  const g = Number.parseInt(raw.slice(2, 4), 16);
  const b = Number.parseInt(raw.slice(4, 6), 16);

  // Extra safety: Number.parseInt can return NaN on unexpected input.
  if ([r, g, b].some((v) => Number.isNaN(v))) return null;

  return { r, g, b };
};

/**
 * YIQ lightness check. The default cutoff is 128 so existing QR views keep
 * black text on medium-light colors. Pass a higher threshold only for a view
 * that needs a stricter cutoff.
 */
const isLight = (
  hexcolor,
  ignoredColors = [],
  threshold = 128,
) => {
  if (!hexcolor) return false;

  const ignoredSet = ignoredColors.length > 0 ? new Set(ignoredColors) : null;

  if (ignoredSet?.has(hexcolor)) {
    return false;
  }

  const rgb = hexToRgb(hexcolor);

  if (!rgb) return false;

  const brightness = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;

  return brightness > threshold;
};

const UI_CONTRAST_YIQ_THRESHOLD = 180;

export { isLight, UI_CONTRAST_YIQ_THRESHOLD };
